// Actions
export const SUPPORT__SUBMIT_MESSAGE = 'SUPPORT__SUBMIT_MESSAGE';
export const SUPPORT__PAUSE_SERVICE = 'SUPPORT__PAUSE_SERVICE';
export const SUPPORT__CANCEL_STANDALONE = 'SUPPORT__CANCEL_STANDALONE';
export const SUPPORT__REPORT_DAMAGE = 'SUPPORT__REPORT_DAMAGE';
export const SUPPORT__CHANGE_FREQUENCY = 'SUPPORT__CHANGE_FREQUENCY';
export const SUPPORT__SKIP_MOW = 'SUPPORT__SKIP_MOW';
export const SUPPORT__GET_SEARCHABLE_ACTIONS = 'SUPPORT__GET_SEARCHABLE_ACTIONS';
export const SUPPORT__MUTATE_SEARCH_QUERY = 'SUPPORT__MUTATE_SEARCH_QUERY';
export const SUPPORT__ONE_TIME_RESCHEDULE = 'SUPPORT__ONE_TIME_RESCHEDULE';
export const SUPPORT__DAY_OF_WEEK_AVAILABILITY = 'SUPPORT__DAY_OF_WEEK_AVAILABILITY';
// Getters
export const SUPPORT__SEARCHABLE_ACTIONS_FILTERED_BY_SEARCH_QUERY =
  'SUPPORT__SEARCHABLE_ACTIONS_FILTERED_BY_SEARCH_QUERY';
// Mutations
export const SUPPORT__RESET = 'SUPPORT__RESET';
export const SUPPORT__MUTATE_LOADING_STATUS = 'SUPPORT__MUTATE_LOADING_STATUS';
export const SUPPORT__MUTATE_SEARCHABLE_ACTIONS = 'SUPPORT__MUTATE_SEARCHABLE_ACTIONS';
export const SUPPORT__MUTATE_DAY_OF_WEEK_AVAILABILITY = 'SUPPORT__MUTATE_DAY_OF_WEEK_AVAILABILITY';
